import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionStatus, config, BalanceQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { utc } from 'moment';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/shared/countdown';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc8 from '@ngx-translate/core';

function AuctionPanelComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "auction.outbid.status"));
} }
function AuctionPanelComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "auction.winning.status"));
} }
class AuctionPanelComponent {
    constructor(balanceQuery) {
        this.balanceQuery = balanceQuery;
        this.ignoreLink = false;
        this.auctionStatus = AuctionStatus;
        this.config = config;
    }
    ngOnInit() {
        this.loyaltyPointsSub = this.balanceQuery.selectPurse(this.config.purseConfig.virtualLoyalty).subscribe((bal) => {
            this.loyaltyPointsCard = bal !== null && bal !== void 0 ? bal : 0;
        });
        this.isComingSoon = this.auctionItem.ComingSoon && utc(this.auctionItem.StartDate) > utc();
        this.isWinning = this.auctionItem.IsWinning === 0 ? false : true;
        this.currentValue = this.auctionItem.CurrentValue;
        this.endDate = this.auctionItem.EndDate;
        this._updateStatus();
    }
    ngOnDestroy() {
        if (this.loyaltyPointsSub) {
            this.loyaltyPointsSub.unsubscribe();
        }
    }
    _updateStatus() {
        this.theme = 'disabled';
        this.ctaTheme = 'secondary';
        if (this.auctionItem.ComingSoon && this.isComingSoon) {
            this.statusText = 'Coming Soon';
        }
        else if (this.auctionItem.PointsValue > this.loyaltyPointsCard) {
            this.statusText = 'Not Enough Points';
        }
        else {
            this.statusText = 'Bid Now';
            this.allowBids = true;
            this.theme = 'auction';
            this.ctaTheme = 'primary';
        }
    }
}
AuctionPanelComponent.ɵfac = function AuctionPanelComponent_Factory(t) { return new (t || AuctionPanelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BalanceQuery)); };
AuctionPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuctionPanelComponent, selectors: [["fgbcl-auction-panel"]], inputs: { ignoreLink: "ignoreLink", auctionItem: "auctionItem" }, decls: 30, vars: 30, consts: [[3, "routerLink"], [1, "card", "loyalty", "border-0", "shadow-sm"], [1, "position-relative"], [3, "ngSwitch"], ["class", "status outbid position-absolute text-center", 4, "ngSwitchCase"], ["class", "status winning position-absolute text-center", 4, "ngSwitchCase"], ["draggable", "false", 1, "card-img-top", 3, "src", "alt", "useDefault", "loyaltyType"], [1, "corner-icon-container", "bg-auction", "text-on-auction"], [1, "corner-icon", 3, "loyaltyType"], [1, "card-img-overlay", "bg-loyalty-gradient", "text-white", "px-3", "pb-2", "pt-3", "rounded-0"], [1, "mb-3", "font-weight-bold", "auction-item-name"], [1, "row"], [1, "col-6", "d-flex"], ["role", "img", 1, "icon", "material-icons", "reward-detail-icons"], [1, "pl-1"], ["role", "img", 1, "icon", "material-icons", "reward-detail-icons", "mr-1"], [3, "endDateTime"], [1, "mx-2", "font-weight-bold"], [1, "status", "outbid", "position-absolute", "text-center"], [1, "status", "winning", "position-absolute", "text-center"]], template: function AuctionPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementContainerStart(3, 3);
        ɵngcc0.ɵɵtemplate(4, AuctionPanelComponent_div_4_Template, 4, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(5, AuctionPanelComponent_div_5_Template, 4, 3, "div", 5);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelement(6, "img", 6);
        ɵngcc0.ɵɵpipe(7, "contentImage");
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelement(9, "fgbcl-loyalty-icon", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 11);
        ɵngcc0.ɵɵelementStart(14, "div", 12);
        ɵngcc0.ɵɵelementStart(15, "span", 13);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵtext(17, "emoji_events");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "span", 14);
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "FortressCurrencyPipe");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 12);
        ɵngcc0.ɵɵelementStart(22, "span", 15);
        ɵngcc0.ɵɵpipe(23, "translate");
        ɵngcc0.ɵɵtext(24, "schedule");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "span");
        ɵngcc0.ɵɵelement(26, "fgbcl-countdown", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "div");
        ɵngcc0.ɵɵelementStart(28, "span", 17);
        ɵngcc0.ɵɵtext(29);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("routerLink", "/rewards/auctions/details/" + ctx.auctionItem.Id);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.auctionItem.Status);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.auctionStatus.UserLosing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.auctionStatus.UserWinning);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind3(7, 19, ctx.auctionItem.ImageUrl, "7", "auction"), ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵpropertyInterpolate("alt", ctx.auctionItem.ItemName);
        ɵngcc0.ɵɵproperty("useDefault", true)("loyaltyType", "auction");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("loyaltyType", "auction");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.auctionItem.ItemName);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(16, 23, "auction.details.points.screenreader"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(20, 25, ctx.currentValue, "PTS"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(23, 28, "auction.details.countdown.screenreader"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate("endDateTime", ctx.endDate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate2("cta ", "bg-" + ctx.theme, " ", "text-on-" + ctx.theme, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.statusText, " ");
    } }, directives: [ɵngcc2.RouterLinkWithHref, ɵngcc3.NgSwitch, ɵngcc3.NgSwitchCase, ɵngcc4.ImgDefaultDirective, ɵngcc5.LoyaltyIconComponent, ɵngcc6.CountdownComponent], pipes: [ɵngcc7.ContentImagePipe, ɵngcc8.TranslatePipe, ɵngcc7.FortressCurrencyPipe], styles: [""] });
AuctionPanelComponent.ctorParameters = () => [
    { type: BalanceQuery }
];
AuctionPanelComponent.propDecorators = {
    auctionItem: [{ type: Input }],
    ignoreLink: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuctionPanelComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-auction-panel',
                template: "<a [routerLink]=\"'/rewards/auctions/details/' + auctionItem.Id\">\r\n  <div class=\"card loyalty border-0 shadow-sm\">\r\n    <div class=\"position-relative\">\r\n      <ng-container [ngSwitch]=\"auctionItem.Status\">\r\n        <div *ngSwitchCase=\"auctionStatus.UserLosing\" class=\"status outbid position-absolute text-center\">\r\n          <span>{{ 'auction.outbid.status' | translate }}</span>\r\n        </div>\r\n        <div *ngSwitchCase=\"auctionStatus.UserWinning\" class=\"status winning position-absolute text-center\">\r\n          <span>{{ 'auction.winning.status' | translate }}</span>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <img\r\n        class=\"card-img-top\"\r\n        src=\"{{ auctionItem.ImageUrl | contentImage: '7':'auction' }}\"\r\n        alt=\"{{ auctionItem.ItemName }}\"\r\n        [useDefault]=\"true\"\r\n        [loyaltyType]=\"'auction'\"\r\n        draggable=\"false\"\r\n      />\r\n      <div class=\"corner-icon-container bg-auction text-on-auction\">\r\n        <fgbcl-loyalty-icon class=\"corner-icon\" [loyaltyType]=\"'auction'\"></fgbcl-loyalty-icon>\r\n      </div>\r\n\r\n      <div class=\"card-img-overlay bg-loyalty-gradient text-white px-3 pb-2 pt-3 rounded-0\">\r\n        <div class=\"mb-3 font-weight-bold auction-item-name\">{{ auctionItem.ItemName }}</div>\r\n        <div class=\"row\">\r\n          <div class=\"col-6 d-flex\">\r\n            <span\r\n              class=\"icon material-icons reward-detail-icons\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'auction.details.points.screenreader' | translate }}\"\r\n              >emoji_events</span\r\n            >\r\n            <span class=\"pl-1\">\r\n              {{ currentValue | FortressCurrencyPipe: 'PTS' }}\r\n            </span>\r\n          </div>\r\n          <div class=\"col-6 d-flex\">\r\n            <span\r\n              class=\"icon material-icons reward-detail-icons mr-1\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'auction.details.countdown.screenreader' | translate }}\"\r\n              >schedule</span\r\n            >\r\n            <span><fgbcl-countdown endDateTime=\"{{ endDate }}\"></fgbcl-countdown></span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"cta {{ 'bg-' + theme }} {{ 'text-on-' + theme }}\">\r\n      <span class=\"mx-2 font-weight-bold\"> {{ statusText }} </span>\r\n    </div>\r\n  </div>\r\n</a>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.BalanceQuery }]; }, { ignoreLink: [{
            type: Input
        }], auctionItem: [{
            type: Input
        }] }); })();

class AuctionPanelModule {
}
AuctionPanelModule.ɵfac = function AuctionPanelModule_Factory(t) { return new (t || AuctionPanelModule)(); };
AuctionPanelModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuctionPanelModule });
AuctionPanelModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PipesModule,
            CountdownModule,
            LoyaltyIconModule,
            DirectivesModule,
            RouterModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuctionPanelModule, { declarations: function () { return [AuctionPanelComponent]; }, imports: function () { return [CommonModule,
        PipesModule,
        CountdownModule,
        LoyaltyIconModule,
        DirectivesModule,
        RouterModule, ɵngcc8.TranslateModule]; }, exports: function () { return [AuctionPanelComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuctionPanelModule, [{
        type: NgModule,
        args: [{
                declarations: [AuctionPanelComponent],
                imports: [
                    CommonModule,
                    PipesModule,
                    CountdownModule,
                    LoyaltyIconModule,
                    DirectivesModule,
                    RouterModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [AuctionPanelComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AuctionPanelComponent, AuctionPanelModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-auctions-auction-panel.js.map